module.exports = __webpack_public_path__ + "images/splash-statup-528ad2.png";